<template>
    <div class="occupation-preview">
        <div class="occupation-preview__label">Pré-visualização</div>
        <div class="occupation-preview__bar">
            <!-- Cada segmento exibe o limite SUPERIOR da sua faixa
                 (o mesmo valor que o usuário digita em cada input). -->
            <div
                class="occupation-preview__segment occupation-preview__segment--green"
                :style="{ width: greenWidth + '%' }"
            >
                <span v-if="greenWidth > 8" class="occupation-preview__text">{{ green }}%</span>
            </div>
            <div
                class="occupation-preview__segment occupation-preview__segment--yellow"
                :style="{ width: yellowWidth + '%' }"
            >
                <span v-if="yellowWidth > 8" class="occupation-preview__text">{{ yellow }}%</span>
            </div>
            <div
                class="occupation-preview__segment occupation-preview__segment--orange"
                :style="{ width: orangeWidth + '%' }"
            >
                <span v-if="orangeWidth > 8" class="occupation-preview__text">{{ red }}%</span>
            </div>
            <div
                class="occupation-preview__segment occupation-preview__segment--red"
                :style="{ width: redWidth + '%' }"
            >
                <span v-if="redWidth > 0" class="occupation-preview__text">100%</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SysAmbienceOccupationPreviewBar',
    props: {
        greenLimit: {
            type: [Number, String],
            default: 60
        },
        yellowLimit: {
            type: [Number, String],
            default: 85
        },
        redLimit: {
            type: [Number, String],
            default: 99
        }
    },
    computed: {
        // Coerção defensiva — props podem chegar como string (v-model de
        // v-text-field em certos fluxos). Labels e cálculos tomam sempre
        // valores numéricos consistentes.
        green() {
            return Number(this.greenLimit) || 0
        },
        yellow() {
            return Number(this.yellowLimit) || 0
        },
        red() {
            return Number(this.redLimit) || 0
        },
        greenWidth() {
            return Math.max(0, Math.min(100, this.green))
        },
        yellowWidth() {
            return Math.max(0, Math.min(100 - this.greenWidth, this.yellow - this.green))
        },
        orangeWidth() {
            return Math.max(0, Math.min(100 - this.greenWidth - this.yellowWidth, this.red - this.yellow))
        },
        redWidth() {
            return Math.max(0, 100 - this.greenWidth - this.yellowWidth - this.orangeWidth)
        }
    }
}
</script>

<style scoped>
.occupation-preview {
    margin-top: 16px;
}

.occupation-preview__label {
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 8px;
    font-weight: 500;
}

.occupation-preview__bar {
    display: flex;
    height: 28px;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.occupation-preview__segment {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: width 0.3s ease;
    min-width: 0;
}

.occupation-preview__segment--green {
    background-color: #28A745;
}

.occupation-preview__segment--yellow {
    background-color: #FFC107;
}

.occupation-preview__segment--orange {
    background-color: #FD7E14;
}

.occupation-preview__segment--red {
    background-color: #DC3545;
}

.occupation-preview__text {
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    white-space: nowrap;
}

.occupation-preview__segment--yellow .occupation-preview__text {
    color: #333;
    text-shadow: none;
}
</style>
